export default __webpack_public_path__ + "static/media/bg-coupon-default-vip.253e2dfb.png";